<template>
  <div class="home">
    <h3 class="title is-3">Home</h3>
    <hr />
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'Manage Branches'}" class="icon-interaction">
            <img src="../assets/branch.png" />
            <h4>Branch</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'Manage Department'}" class="icon-interaction">
            <img src="../assets/department.png" />
            <h4>Department</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'Manage Job Title'}" class="icon-interaction">
            <img src="../assets/id-card-2.png" />
            <h4>Job Title</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'List Of Employees'}" class="icon-interaction">
            <img src="../assets/user-6.png" />
            <h4>Employee</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'TimeSheet Module'}" class="icon-interaction">
            <img src="../assets/alarm-clock-1.png" />
            <h4>Timesheet</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <router-link :to="{name: 'List Of Leave'}" class="icon-interaction">
            <img src="../assets/exit-1.png" />
            <h4>Leave</h4>
          </router-link>
        </article>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'Manage Holiday'}" class="icon-interaction">
            <img src="../assets/calendar-1.png" />
            <h4>Holidays</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'List Of Payrolls'}" class="icon-interaction">
            <img src="../assets/payslip.png" />
            <h4>Payroll</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'Report Module'}" class="icon-interaction">
            <img src="../assets/diagram.png" />
            <h4>Reports</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'List Of Newsfeed'}" class="icon-interaction">
            <img src="../assets/newspaper.png" />
            <h4>Blog</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'Document'}" class="icon-interaction">
            <img src="../assets/folder-14.png" />
            <h4>Documents</h4>
          </router-link>
        </article>
      </div>
      <div class="tile is-parent is-2">
        <article class="tile is-child box">
          <router-link :to="{name: 'List of Users'}" class="icon-interaction">
            <img src="../assets/unlocked.png" />
            <h4>User Management</h4>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<style>
.icon-interaction:hover img {
  opacity: 0.8;
  transition: 0.5s ease;
  transform: scale(1.1);
}
.icon-interaction img {
  transition: 0.5s ease-out;
}
</style>

<script>
// @ is an alias to /src
export default {
  title: 'Home Page',
  name: 'home'
}
</script>
